import { AppState } from '../../types';
import {
  ImageInstructionState,
  TextInstructionState,
  NoteInstructionState,
  VideoInstructionState,
  TitleInstructionState,
  NameScriptInstructionState,
  WebPageInstructionState,
  DocumentPageInstructionState,
  AudioInstructionState,
} from './types';

export const selectImageInstruction = (state: AppState): ImageInstructionState => state.scriptEditor.imageInstruction;
export const selectTextInstruction = (state: AppState): TextInstructionState => state.scriptEditor.textInstruction;
export const selectNoteInstruction = (state: AppState): NoteInstructionState => state.scriptEditor.noteInstruction;
export const selectVideoInstruction = (state: AppState): VideoInstructionState => state.scriptEditor.videoInstruction;
export const selectTitleInstruction = (state: AppState): TitleInstructionState => state.scriptEditor.titleInstruction;
export const selectNameScriptInstruction = (state: AppState): NameScriptInstructionState => state.scriptEditor.nameScriptInstruction;
export const selectWebPageInstruction = (state: AppState): WebPageInstructionState => state.scriptEditor.webPageInstruction;
export const selectDocumentPageInstruction = (state: AppState): DocumentPageInstructionState => state.scriptEditor.documentPageInstruction;
export const selectAudioInstruction = (state: AppState): AudioInstructionState => state.scriptEditor.audioInstruction;
